<div class="lease-docs-notice is-muted" *ngIf="leasesLoading" role="status">
  <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
  <span class="notice-text">Cargando la copia del expediente en cada arrendamiento…</span>
</div>

<div class="lease-docs-notice is-error" *ngIf="leasesError" role="alert">
  <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
  <span class="notice-text">No se pudieron cargar los arrendamientos del cliente. El expediente sigue disponible.</span>
  <button pButton type="button" class="p-button-text p-button-sm" label="Reintentar" (click)="loadLeases()"></button>
</div>

<p-tabView styleClass="tabview-plain customer-docs-tabs">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="fa-solid fa-folder-open" aria-hidden="true"></i>
      <span>Expediente</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-customer-documents mode="client" [client]="client" (changed)="changed.emit()"></app-customer-documents>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel *ngFor="let lease of leases; let i = index; trackBy: trackById">
    <ng-template pTemplate="header">
      <i class="fa-solid fa-file-contract" aria-hidden="true"></i>
      <span>{{ leaseLabel(lease, i) }}</span>
    </ng-template>
    <ng-template pTemplate="content">
      <app-customer-documents
        *ngIf="lease.documents; else noCopyTpl"
        mode="lease-readonly"
        [docsEntity]="lease.documents"
        [entityType]="lease.documentType"
        [ownerRfc]="client?.rfc"
      ></app-customer-documents>
      <ng-template #noCopyTpl>
        <div class="empty-state">
          <i class="fa-solid fa-folder-open" aria-hidden="true"></i>
          <h3>Este arrendamiento todavía no tiene copia del expediente</h3>
          <p>Los documentos del cliente se copian desde el arrendamiento, en su pestaña Documentos.</p>
        </div>
      </ng-template>
    </ng-template>
  </p-tabPanel>
</p-tabView>
